// extracted by mini-css-extract-plugin
export var hr = "hr-module--hr--P9hSC";